import { doc, getDoc, updateDoc } from "firebase/firestore"
import { useContext, useState } from "react"
import Option from "../../components/option"
import Timer from "../../components/timer"
import { db } from "../../firebase/firebase"
import { questions } from "../../questions-array/questions"
import ScoreContext from "../../store/score-context"
import TimerContext from "../../store/timerState/timer-context"
import { timeTaken } from "../../store/timerState/timer-provider"
import classes from './game-styles.module.css'
const Game = (props) => {
    const scoreCtx = useContext(ScoreContext);
    // const timerCtx = useContext(TimerContext);
    const [currentQuestion, setCurrentQuestion] = useState(0)
    const [isRightAnswer, setRightAnswer] = useState(false) //indicates that we answered the right answer
    const [chose, setChose] = useState(false)
    const [timeValue, setTimeValue] = useState(0)
    const [memesRightAnswers, setmemesRightAnswers] = useState(0)
    const [complianceRightAnswers, setComplianceRightAnswers] = useState(0)
    const updateQuestionOnFirebase = async (optionObj) => {
        console.log('TTTT : ', timeTaken);
        let tempTimeTaken = timeTaken;
        const ref = doc(db, "MCQ-friends", scoreCtx.randomId.toString());
        const docSnap = await getDoc(ref);
        let tempDoc = docSnap.data();
        if (!tempDoc.questions) tempDoc.questions = [];
        let question = questions[currentQuestion].question
        tempDoc.questions[currentQuestion] = {
            questionTitle: question,
            chosenAnswer: optionObj,
            timeTaken: tempTimeTaken
        }
        await updateDoc(ref, {
            questions: tempDoc.questions
        });
    }
    function nextQuestionHandler(optionObj) {
        updateQuestionOnFirebase(optionObj)
        setTimeout(() => {
            if (currentQuestion < questions.length - 1) {
                setCurrentQuestion(currentQuestion + 1)
            }
            else {
                props.onFinish(true, memesRightAnswers, complianceRightAnswers)
            }
            setChose(false)
        }, 1000)
    }
    function scoreHandler(valid) {
        if (valid) {
            if (questions[currentQuestion].type === 'compliance') {
                setComplianceRightAnswers(complianceRightAnswers + 1)
                scoreCtx.increaseCompliance()
            }
            else if (questions[currentQuestion].type === 'nazer') {
                setmemesRightAnswers(memesRightAnswers + 1)
                scoreCtx.increaseMemes()
            }
            setRightAnswer(true) // indicates that we answered the right answer
        }
        else {
            setRightAnswer(false)
        }
    }
    function Options() {
        return questions[currentQuestion].options.map((value, index) => {
            return (<Option
                isRightAnswer={isRightAnswer}
                key={index}
                option={value}
                chose={chose}
                currentQuestion={questions[currentQuestion]}
                onClick={
                    (optionObj) => {
                        setChose(true)
                        scoreHandler(value.valid)
                        nextQuestionHandler(optionObj)
                    }
                } />
            )
        })
    }
    return (<div className={classes.gameContainer}>
        <div className={classes.timerContainer}>
            <Timer chose={chose} onTimeOut={() => {
                setChose(true)
                scoreHandler(false)
                nextQuestionHandler('timeout')
            }} />
        </div>
        <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className={classes.questionsAndOptionsContainer}  >
                <p className={classes.question} style={questions[currentQuestion].type == 'compliance' ? { fontFamily: 'Eraser', fontWeight: 'bold' } : { fontFamily: 'friends' }}>{questions[currentQuestion].question}</p>
                <div className={classes.optionsContainer} >
                    <Options />
                </div>
            </div>
        </div>
    </div >)
}
export default Game;